import { IMAGE_QUALITY_HOMEPAGE_CARD } from '@/constants/image-quality';

/** Logical (CSS px) render size per card shape. */
export const CARD_LOGICAL_SIZE = {
  square: 230,
  portrait: 315,
} as const;

interface BuildGenericCardImageSrcArgs {
  imagesPath: '/images' | '/related-images';
  imageId: string;
  /** Logical CSS px size of the card (see CARD_LOGICAL_SIZE). */
  size: number;
  /**
   * Device-pixel-ratio multiplier for the Directus source. The Directus URL
   * bakes in width/height, so the fetched source is NOT upscaled by the
   * Next.js optimizer beyond this cap. Pass 2 to serve a retina-sharp source
   * where the rendered CSS box is ~2x the logical `size` in device pixels.
   * Defaults to 1 to preserve the historical behavior for callers that don't
   * opt in.
   */
  sourceDpr?: number;
  /** Directus-side compression quality. Defaults to the homepage-card value. */
  quality?: number;
}

/**
 * Build the Directus asset URL for a GenericCard image.
 */
export function buildGenericCardImageSrc({
  imagesPath,
  imageId,
  size,
  sourceDpr = 1,
  quality = IMAGE_QUALITY_HOMEPAGE_CARD,
}: BuildGenericCardImageSrcArgs): string {
  const sourceSize = size * sourceDpr;
  return `${imagesPath}/${imageId}?fit=outside&width=${sourceSize}&height=${sourceSize}&quality=${quality}`;
}
